export default __webpack_public_path__ + "static/media/clases-dirigidas.eddde8c5.jpg";